import IconButton from '@/components/ui/custom/buttons/IconButton';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import OutlinedSelect, {
  OutlineSelectOption,
} from '@/components/ui/custom/dataInput/OutlinedSelect';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { twMerge } from 'tailwind-merge';

type CourseFilterSelectProps<T> = {
  text: string;
  options: OutlineSelectOption<T>[];
  selectedValue?: T;
  onSelect?(value: T): void;
  onDeselect?(): void;
  className?: Pick<ClassNameComponent, 'base'>;
};

export default function CourseFilterSelect<T>({
  text,
  options,
  selectedValue,
  onSelect,
  onDeselect,
  className,
}: CourseFilterSelectProps<T>) {
  return (
    <div className={twMerge('flex gap-1 items-center', className?.base)}>
      <Text text={text} className="text-14 lg:text-16" />
      <OutlinedSelect
        options={options}
        offset={[4, 4]}
        selectedValue={selectedValue}
        className={{
          text: 'opacity-100 !text-secondary text-14 font-600',
        }}
        onSelectValue={onSelect}
      />
      <ConditionalRenderer condition={!!onDeselect}>
        <IconButton
          onClick={onDeselect}
          icon={<XMarkIcon className="w-4 h-4" />}
          className="text-error"
        />
      </ConditionalRenderer>
    </div>
  );
}
